<template>
  <v-main>
    <v-container fluid>
      <v-file-input v-model="file" @change="uploadFile" />
      <v-btn @click="getData">Teste fetch</v-btn>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'teste',
  data () {
    return {
      file: null
    }
  },
  methods: {
    uploadFile () {
      const data = new FormData()
      data.append('file', this.file)
      this.$store.dispatch('clubhouseApi', { method: 'POST', url: 'files', body: data })
        .then((response) => {
          console.log(response)
        }).catch((e) => {
          console.log(e)
        })
    },
    getData () {
      this.$store.dispatch('clubhouseApi', { method: 'GET', url: 'search/stories', params: { page_size: 25, query: 'project:Backoffice' } })
        .then((response) => {
          console.log(response)
        }).catch((e) => {
          console.log(e)
        })
    }
  }
}
</script>
